<template>
    <div style="height:92%;overflow-y:scroll;" class="int inLegal">
        <dagen v-if="company == 4"></dagen>
        <bayrol v-if="company == 3"></bayrol>
        <div v-else>
            <es v-if="currentLanguage === 'es'"></es>
            <en v-if="currentLanguage === 'en'"></en>
            <fr v-if="currentLanguage === 'fr'"></fr>
            <it v-if="currentLanguage === 'it'"></it>
            <de v-if="currentLanguage === 'de'"></de>
            <en v-if="currentLanguage === 'cz'"></en>
            <en v-if="currentLanguage === 'nl'"></en>
            <en v-if="currentLanguage === 'pt'"></en>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import es from './Legal/es.vue'
import en from './Legal/en.vue'
import fr from './Legal/fr.vue'
import it from './Legal/it.vue'
import de from './Legal/de.vue'
import dagen from './Legal/dagen.vue'
import bayrol from './Legal/bayrol.vue'

export default {
    name: 'terms',
    components: {es,en,fr,it,de,dagen, bayrol},
    props: {
        company: Number
    },
    data: function () {
        return {
            
        }
    },

    computed: {
        currentLanguage: function () {
            var lang =  (this.$route.params.lang && this.$route.params.lang!='') ? this.$route.params.lang : this.$i18n.locale;
            var index = this.languages.map((o) => o.code).indexOf(lang);
            return this.languages[index].code;
        },
        ...mapState(['languages', 'actionCodeSettings', 'userProfile'])
    },
}
</script>

<style scoped>
p {
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Terms.vue